import { render, staticRenderFns } from "./VisitorPorsantDocumentList.vue?vue&type=template&id=777c03f2&"
import script from "./VisitorPorsantDocumentList.vue?vue&type=script&lang=js&"
export * from "./VisitorPorsantDocumentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports